import store from 'storejs';

export default {
  get: store.get,
  set: store.set,
  remove: store.remove,
  clear: store.clear,
  keys: store.keys,
  forEach: store.forEach,
  search: store.search
};
